import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteUser as deleteUserApi } from '../services/apiUsers.ts'
import { toast } from '../utils/sweetAlert.ts'

export function useDeleteUser(id: string | number) {
  const queryClient = useQueryClient()

  const { isLoading: isDeleting, mutate: deleteUser } = useMutation({
    mutationFn: deleteUserApi,
    onSuccess: () => {
      queryClient.invalidateQueries(['users'])
      toast('success', `${id} account has been successfully deleted!`)
    },
    onError: (error: any) => {
      toast('error', `Something went wrong! ${error.message}`)
    },
  })

  return { isDeleting, deleteUser }
}
